module.exports = __webpack_public_path__ + "fa-solid-900.e8a427e15cc502bef99c.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-solid-900.woff2
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.woff2
// module chunks = styles